import createIcon from '../../createIcon';

/**
 * @component @name Group
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMTFDMTcuNjYgMTEgMTguOTkgOS42NiAxOC45OSA4QzE4Ljk5IDYuMzQgMTcuNjYgNSAxNiA1QzE0LjM0IDUgMTMgNi4zNCAxMyA4QzEzIDkuNjYgMTQuMzQgMTEgMTYgMTFaTTggMTFDOS42NiAxMSAxMC45OSA5LjY2IDEwLjk5IDhDMTAuOTkgNi4zNCA5LjY2IDUgOCA1QzYuMzQgNSA1IDYuMzQgNSA4QzUgOS42NiA2LjM0IDExIDggMTFaTTggMTNDNS42NyAxMyAxIDE0LjE3IDEgMTYuNVYxOUgxNVYxNi41QzE1IDE0LjE3IDEwLjMzIDEzIDggMTNaTTE2IDEzQzE1LjcxIDEzIDE1LjM4IDEzLjAyIDE1LjAzIDEzLjA1QzE2LjE5IDEzLjg5IDE3IDE1LjAyIDE3IDE2LjVWMTlIMjNWMTYuNUMyMyAxNC4xNyAxOC4zMyAxMyAxNiAxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Group = createIcon('Group', [
  [
    'path',
    {
      d: 'M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z',
      key: '1cij0w',
    },
  ],
]);

export default Group;
